// NonMobileEnrollmentSection.tsx
import { BaseCachedPharmacyCustomerProvider, ProviderProps } from "./BaseCachedPharmacyCustomerProvider";
import { nonMobileEnrollmentCustomerTypeMapping, nonMobileEnrollmentCustomerTypePaths } from "../../constants/non-mobile-enrollment-config";

class NonMobileEnrollmentSection extends BaseCachedPharmacyCustomerProvider {
  static defaultProps: ProviderProps = {
    customerTypePaths: nonMobileEnrollmentCustomerTypePaths,
    customerTypeMapping: nonMobileEnrollmentCustomerTypeMapping,
    title: "Non Mobile Enrollment Customers",
    dashboardLink: "https://w.amazon.com/bin/view/Pharmacy/Public/Teams/PharmacySDET/CPCPCustomerDashboard-ApaqPortalUIBeta/"
  };

  constructor(props: ProviderProps) {
    super(props);
    this.state = {
      ...this.state,
      customerType: "NMECustomerWithHealthProfile"
    };
  }
}

export default NonMobileEnrollmentSection;
